import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api/_client";

/**
 * Whether a feature flag is on for the signed-in user's tenant. The check is an
 * advisor-session endpoint: pass `enabled: false` where a component may render
 * without one (the client flow), so it never calls it.
 */
export function useFeatureFlag(flagKey: string, options: { enabled?: boolean } = {}) {
  const { data, isLoading } = useQuery({
    queryKey: ["featureFlags", flagKey],
    queryFn: () => get<{ enabled: boolean }>(`/internal/admin/feature-flags/check/${flagKey}`),
    staleTime: 5 * 60 * 1000,
    enabled: options.enabled ?? true,
  });
  return { enabled: data?.enabled ?? false, isLoading };
}
